import { EthereumWalletConnectors } from '@dynamic-labs/ethereum';
import {
  DynamicContextProvider,
  SortWallets,
} from '@dynamic-labs/sdk-react-core';
import { SolanaWalletConnectors } from '@dynamic-labs/solana';

interface DynamicProviderProps {
  children: React.ReactNode;
  chains?: ('evm' | 'sol')[];
  dynamicEnvironmentId?: string;
}

/**
 * DynamicProvider component that provides the Dynamic context to its children.
 * @component
 * @param {DynamicProviderProps} props - The properties for the component.
 * @param {React.ReactNode} props.children - The child components to be wrapped by the Dynamic context.
 * @param {('evm' | 'sol')[]} [props.chains=['evm']] - The chains to be used.
 * @returns {JSX.Element} The DynamicProvider component.
 */
export const DynamicProvider: React.FC<DynamicProviderProps> = ({
  children,
  chains = ['evm'],
  dynamicEnvironmentId,
}: DynamicProviderProps) => {
  const walletConnectors = [
    chains.includes('evm') ? EthereumWalletConnectors : null,
    chains.includes('sol') ? SolanaWalletConnectors : null,
  ].filter((connector) => connector !== null);

  return (
    <DynamicContextProvider
      settings={{
        environmentId:
          dynamicEnvironmentId ??
          process.env.NEXT_PUBLIC_DYNAMIC_ENVIRONMENT_ID!,
        walletConnectors: walletConnectors,
        walletsFilter: SortWallets(['phantom']),
        appName: 'Doodles',
        privacyPolicyUrl: 'https://doodles.app/privacy-policy',
        termsOfServiceUrl: 'https://doodles.app/terms',
      }}
    >
      {children}
    </DynamicContextProvider>
  );
};
